module.exports = __webpack_public_path__ + "img/logo-desktop.2e4304b3.png";